<!-- Translated: skip -->
<template>
  <div class="component">
    <transition name="animate-filter">
      <div v-if="activeFiltersCount > 0" class="active-filters-list">
        <span class="label">Valda filter:</span>
        <ul>
          <li v-for="(value, filter) in activeFilters">
            <FilterListItem :filter="filter" :label="(filter === 'locationId' ? ('Område: ' + area(value)) : null)" :value="value" @click="awaitFilter(); resetAccomodationsFilter(filter)" />
          </li>
        </ul>
      </div>
    </transition>
    <div class="info">
      <span class="text" v-if="poolCount > 1">
        <strong>{{ unitCount }}</strong> resultat (över {{poolCount}} områden),
        <span>{{selectedFilterObject.explanation}}</span>
      </span>
      <span class="text" v-if="poolCount <= 1">
        <strong>{{ unitCount }}</strong> resultat
      </span>
      <span class="text">
        <button ref="resetButton" class="reset-button reset-filter-text" @click="reset()" v-show="activeFiltersCount > 0 || $store.state.accomodationsFilter.freeSearch">
          Återställ filter <icon name="Reset" :scale="1.3" />
        </button>
      </span>
      <div class="sort-filter">
        <Dropdown
          :options="filters"
          :validated="selectedFilter && selectedFilter.value"
          :value="selectedFilter"
          :label="(selectedFilter && selectedFilter.value) ? ('Sortering: ' + (selectedFilter.title)) : 'Sortera efter'"
          :with-background="true"
          @changed="changedSorting"
          :bold-label="true"
          @clicked-suffix="changedSorting({})"
          type="clean">
        </Dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import {
  size,
} from 'lodash/fp';
import FilterListItem from '@/components/parts/Accomodation/List/Filter/FilterListItem';
import { mapMutations } from 'vuex';

import Dropdown from '@/components/components/Dropdown';

import API from '@/classes/API';

export default {
  props: {
    unitCount: {},
    poolCount: {},
  },
  data() {
    return {
      pools: [],
      selectedFilter: null,
      filters: [{
        value: 'random',
        title: 'Slumpad',
        explanation: 'slumpad ordning',
      }, {
        value: 'price',
        title: 'Pris',
        explanation: 'lägst pris först',
      }],
    };
  },
  components: {
    FilterListItem,
    Dropdown,
  },
  computed: {
    activeFilters() {
      const localFilters = this.$store.state.accomodationsFilter;

      const newFilters = {};

      const filtersAsArray = Object.entries(localFilters);

      filtersAsArray.forEach((filter) => {
        const key = filter[0];
        const value = filter[1];

        switch (key) {
          case 'beds':
          case 'bedrooms':
            if (value > 1) {
              newFilters[key] = value;
            }
            break;
          case 'date':
            if (value.startDate && value.endDate) {
              newFilters[key] = value;
            }
            break;
          case 'availabelIds':
          case 'freeSearch':
            break;
          default:
            if (value) {
              newFilters[key] = value;
            }
            break;
        }
      });

      return newFilters;
    },
    activeFiltersCount() {
      return size(this.activeFilters);
    },
    selectedFilterObject() {
      const filters = this.filters.filter(
        f => f.value === this.$store.state.accomodationsFilter.sorting);

      if (filters.length) {
        return filters[0];
      }

      return this.filters[0];
    },
  },
  beforeMount() {
    if (this.SITE_CONFIG.site === 'branas') {
      this.filters.push({
        value: 'site-2006',
        title: 'Berget',
        explanation: 'boenden på Berget först',
      });
      this.filters.push({
        value: 'site-2007',
        title: 'Dalen',
        explanation: 'boenden i Dalen först',
      });
      this.filters.push({
        value: 'site-2020',
        title: 'Mattesdalen',
        explanation: 'boenden i Mattesdalen först',
      });
    }

    this.filters.push({
      value: 'alphabetical',
      title: 'A-Ö',
      explanation: 'bokstavsordning',
    });

    if (this.$store.state.accomodationsFilter.sorting) {
      const first = this.filters.find(value =>
        value.value === this.$store.state.accomodationsFilter.sorting);
      if (first) {
        this.selectedFilter = first.value;
      }
    }
  },
  mounted() {
    this.fetchPools();
  },
  methods: {
    ...mapMutations([
      'resetAccomodationsFilter',
      'awaitFilter',
      'changeSorting',
    ]),
    async fetchPools() {
      const { data } = await API.get('/areas');
      this.pools = data;
    },
    area(id) {
      let pool = {};
      if (this.pools) {
        pool = this.pools.find(p => id === p.id);
      }
      if (pool) {
        return pool.display_name || pool.name;
      }
      return '';
    },
    reset() {
      const $this = this;
      $this.$refs.resetButton.className = 'reset-button animation';
      $this.resetAccomodationsFilter();
      this.awaitFilter();
      setTimeout(() => {
        $this.$refs.resetButton.className = 'reset-button';
      }, 1000);
    },
    changedSorting(value) {
      this.changeSorting({ value: value.value });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.component
  transition-slide('animate-filter')

.component
  max-width container-width
  margin-right auto
  margin-left auto
  font-size 14px
  padding-top space-1

.active-filters-list
  margin-top - space-1
  margin-bottom - space-1
  padding-top space-1
  display flex
  align-items center
  position relative
  z-index 0
  padding-left space-2
  padding-right space-2
  +max-mobile()
    flex-wrap: wrap
  .label
    font-weight bold
    flex none
    padding-top space-1
    padding-bottom space-1
    position relative
    top -.0625em
    margin-top: 0;
    margin-bottom: auto;
    padding-top: 0.8rem;
    +max-mobile()
      padding-left: 1rem;
  ul
    display flex
    align-items center
    flex-wrap wrap
    flex auto
    list-style none
    padding 0
    margin-top: auto;
    margin-bottom: auto;
    li
      padding-top space-1
      padding-bottom space-1
      padding-left space-2

.reset-button
  button-reset()

.reset-filter-text
  &:hover
    border 0px
    text-decoration underline

.reset-button .icon--Reset
  transition: none
.reset-button.animation .icon--Reset
  transform: rotate(360deg);
  transition: all 1s

.info
  display flex
  margin - space-2
  align-items center
  padding-top space-1
  +max-mobile()
    flex-wrap: wrap;
  +max-tablet()
    margin-left: 0
    margin-right: 0

  .sort-filter
    flex-grow: 1
    padding-right: 15px
    margin-top: 15px;
    .dropdown-wrapper
      max-width 170px
      float: right;

  .text
    padding space-2
    position relative
    margin-top: 10px;
    margin-bottom: -8px;
    :after
      width 1px
      position absolute
      left 0
      top 10px
      height 27px
      content ""
      border-right solid 1px rgba(191, 217, 225, 0.5);
    &:nth-child(1) :after
      display none
</style>



// WEBPACK FOOTER //
// AccomodationsFilterInfo.vue?6563afd4